







import { Vue, Component } from "vue-property-decorator";
import Prism from "vue-prism-component";

import { namespace } from "vuex-class";

const Integration = namespace("integration");

@Component({
  components: {
    prism: Prism,
  },
})
export default class Android extends Vue {
  @Integration.Getter("getPublicKey") publicKey;
  @Integration.Getter("getSecretKey") secretKey;

  code = '';

  created() {
    this.code = `
import com.orbaone.orba_one_capture_sdk_core.OrbaOne;

OrbaOne oneSdk = new OrbaOne.Builder()
                      .setApiKey("${this.publicKey}")
                      .setApplicantId("applicant-id")
                      .create();

oneSdk.startVerification(this);`;
  }
}
